import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import CompanyDetailsForm1 from "../components/CompanyDetailsForm1";
import CompanyDetailsForm2 from "../components/CompanyDetailsForm2";
import CompanyDetailsForm3 from "../components/CompanyDetailsForm3";
import CompanyDetailsForm4 from "../components/CompanyDetailsForm4";
import OTPPopup from "../components/OTPPopup";
import { useNavigate } from "react-router-dom";

function AddCompanyPage() {
  const [formNum, setFormNum] = useState(1);
  const [isOTPPopupVisible, setIsOTPPopupVisible] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    region: "",
    country: "",
    address: "",
    zipcode: "",
    phone: "",
    website: "",
    prime_category: "",
    secondary_category: "",
    logo: null,
    banner_image: null,
    region2: "",
    country2: "",
    address2: "",
    zipcode2: "",
    phone2: "",
    website2: "",
    email2: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("full_name", formData.full_name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("region", formData.region);
      formDataToSend.append("country", formData.country);
      formDataToSend.append("address", formData.address);
      formDataToSend.append("zipcode", formData.zipcode);
      formDataToSend.append("phone", formData.phone);
      formDataToSend.append("website", formData.website);
      formDataToSend.append("prime_category", formData.prime_category);
      formDataToSend.append("secondary_category", formData.secondary_category);
      formDataToSend.append("logo", formData.logo);
      formDataToSend.append("banner_image", formData.banner_image);
      formDataToSend.append("region2", formData.region2);
      formDataToSend.append("country2", formData.country2);
      formDataToSend.append("zipcode2", formData.zipcode2);
      formDataToSend.append("address2", formData.address2);
      formDataToSend.append("phone2", formData.phone2);
      formDataToSend.append("website2", formData.website2);
      formDataToSend.append("email2", formData.email2);
      const response = await axios.post(
        "/api/vendor_registration.php",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFormData({
        full_name: "",
        email: "",
        region: "",
        country: "",
        address: "",
        zipcode: "",
        phone: "",
        website: "",
        prime_category: "",
        secondary_category: "",
        logo: null,
        banner_image: null,
        region2: "",
        country2: "",
        address2: "",
        zipcode2: "",
        phone2: "",
        website2: "",
      });
      // console.log(formData);
      // console.log(response.data.status);
      navigate('/thankyou', {state: {message: "Thankyou for submitting the form."}})
    } catch (error) {
      console.error("Error submitting form:", error);
      setPopupMessage("An error occured while submitting the form. Try again later.")
      setShowPopup(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowPopup(false);
    }, 5000)
  }, [showPopup])

  const handleOTPSubmit = () => {
    setIsOTPPopupVisible(false);
  };

  const renderForm = () => {
    switch (formNum) {
      case 1:
        return (
          <CompanyDetailsForm1
            setFormNum={setFormNum}
            setFormData={setFormData}
            formData={formData}
          />
        );
      case 2:
        return (
          <CompanyDetailsForm2
            setFormNum={setFormNum}
            setFormData={setFormData}
            username={formData.full_name}
            email={formData.email}
            formData={formData}
          />
        );
      case 3:
        return (
          <CompanyDetailsForm3
            setFormNum={setFormNum}
            setFormData={setFormData}
            formData={formData}
          />
        );
      case 4:
        return (
          <CompanyDetailsForm4
            setIsOTPPopupVisible={setIsOTPPopupVisible}
            setFormData={setFormData}
            userEmail={formData.email}
            setFormNum={setFormNum}
            formData={formData}
            loading={loading}
          />
        );
      default:
        return <p>Invalid Form Number</p>;
    }
  };

  return (
    <div className="font-inter min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow flex flex-col items-center justify-center px-4">
        <div className="w-full max-w-5xl px-4 lg:px-8 mx-auto">
          <h2
            className="text-4xl xl:text-5xl 2xl:text-6xl font-bold text-[#111827] text-center"
            style={{ marginTop: "calc((100vh - 10rem) / 28)" }}
          >
            Add New Company
          </h2>
          <p className="text-[#4E5562] text-center mt-[3.5vh] text-sm sm:text-base xl:text-base 2xl:text-lg mx-4 sm:mx-14 md:mx-36 lg:mx-44 2xl:mx-">
            Listings on Elso is free. Verify and provide more information to reach out to the maximum business leads.
          </p>
        </div>
        <div className="w-full max-w-md lg:max-w-lg xl:max-w-2xl mx-auto px-4 lg:px-8">
          {renderForm()}
        </div>
      </div>
      <Footer />
      {isOTPPopupVisible && (
        <OTPPopup
          onClose={handleOTPSubmit}
          handleSubmit={handleSubmit}
          userEmail={formData.email}
          setFormNum={setFormNum}
        />
      )}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="fixed inset-0 bg-white bg-opacity-65 backdrop-filter backdrop-blur-sm transition-opacity duration-300 ease-in-out"></div>
          <div className="bg-[#006A4E] text-white p-4 rounded-xl shadow-md transition-transform duration-300 ease-in-out transform">
            {popupMessage}
          </div>
        </div>
      )}
    </div>
  );
}

export default AddCompanyPage;